module.exports = __webpack_public_path__ + "img/java_do_not_copy_eir.a8713361.png";